import { AnimatePresence, motion } from "motion/react"
import { useCallback } from "react"
import { createPortal } from "react-dom"

import styles from "./index.module.scss"

interface Props {
    open: boolean
    src?: string | null
    onClose: () => void
}

export const ImagePreview: React.FC<Props> = ({ open, src, onClose }) => {
    const handleMaskClick = useCallback(() => {
        onClose()
    }, [onClose])

    const stopPropagation = useCallback(
        (e: React.MouseEvent) => e.stopPropagation(),
        [],
    )

    return createPortal(
        <AnimatePresence>
            {open && src && (
                <motion.div
                    className={styles.mask}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    onClick={handleMaskClick}
                >
                    <motion.div
                        className={styles.container}
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.8 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        onClick={stopPropagation}
                    >
                        <img
                            className={styles.image}
                            src={src}
                            alt=""
                            draggable={false}
                        />
                        <button
                            className={styles.close}
                            type="button"
                            aria-label="close"
                            onClick={onClose}
                        />
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>,
        document.body,
    )
}
